import React, {Component} from 'react'

import { connect } from 'react-redux'
import SettingsBulkFilterZip from './components/Settings/SettingsBulkFilterZip'

import {
  setTitle
} from 'common/redux/root'

const mapDispatchToProps = dispatch => ({
    dispatch
})

class SettingsBulkFilterZipContainer extends Component {

  constructor(props) {
    super(props)
  }

  componentWillMount() {
    this.props.dispatch(setTitle("Browse Zip Codes"))
  }

  render() {
    return <SettingsBulkFilterZip {...this.props} />
  }

}

export default connect((state) => ({ settings: state.settings, auth: state.auth }), mapDispatchToProps)(SettingsBulkFilterZipContainer)
